import {Component, OnDestroy, OnInit, inject} from '@angular/core';
import {API, AssetRepositoryFullDTO} from 'src/app/services/api/api';
import {UtilService} from '../../../../services/util.service';
import {ModalNavigationComponent} from '../../../../services/gui/modal/modal-navigation-component';
import {ModalNavigationService} from '../../../../services/gui/modal/modal-navigation.service';
import {PermissionService} from '../../../../services/permission.service';
import {AssetService} from '../../../../services/assets/asset.service';

@Component({
  selector: 'sb-page-repositories-list',
  templateUrl: './repositories-list.component.html',
  styleUrls: ['./repositories-list.component.scss'],
  standalone: false,
})
export class RepositoriesListComponent implements OnInit, ModalNavigationComponent, OnDestroy {
  public readonly modalNavigationService = inject(ModalNavigationService);
  public readonly api = inject(API);
  public readonly util = inject(UtilService);
  public readonly assetService = inject(AssetService);
  public readonly permissionService = inject(PermissionService);

  isInModalContext: boolean;

  ngOnInit(): void {}

  selectRepository(repo: AssetRepositoryFullDTO) {
    if (this.isInModalContext) {
      this.modalNavigationService.result(repo);
    }
  }

  ngOnDestroy() {
    this.assetService.selectedRepository = null;
    this.assetService.showSideBar = false;
  }

  applyFiltering(filterMap: Map<string, any[]>) {
    this.setRequestOptions(filterMap);
    this.assetService.requestDebouncedAssets();
  }

  setRequestOptions(filterMap: Map<string, any[]>) {
    this.assetService.searchRepositories = filterMap.get('search')?.[0];
    this.assetService.exactMatchRepositories = filterMap.get('exactMatch')?.[0];
  }
}
